import {
    BILLING_HISTORY_FAILURE,
    BILLING_HISTORY_REQUEST,
    BILLING_HISTORY_SUCCESS,
    INVOICE_REQUEST,
    INVOICE_SUCCESS,
    INVOICE_FAILURE,
    Invoice,
    InvoicesResponse
} from '../../actions/truckLoadRate/billingHistoryActions';

export interface BillingHistory {
    invoice: Invoice | {};
    isFetchingHistory: boolean;
    invoicesResponse: InvoicesResponse | { content: Invoice[] };
    isDownloadingInvoice: boolean;
}

const fetchBillingHistoryReducers = (billingHistory: BillingHistory = {
    invoice: {},
    isFetchingHistory: false,
    invoicesResponse: { content: [] },
    isDownloadingInvoice: false
}, action: any): BillingHistory => {
    switch (action.type) {
        case BILLING_HISTORY_REQUEST: {
            return {
                ...billingHistory,
                isFetchingHistory: true
            };
        }
        case BILLING_HISTORY_SUCCESS: {
            return {
                ...billingHistory,
                isFetchingHistory: false,
                invoicesResponse: action.payload
            };
        }
        case BILLING_HISTORY_FAILURE: {
            return {
                ...billingHistory,
                isFetchingHistory: false,
                invoicesResponse: { content: [] }
            };
        }
        case INVOICE_REQUEST: {
            return {
                ...billingHistory,
                isDownloadingInvoice: true
            };
        }
        case INVOICE_SUCCESS: {
            return {
                ...billingHistory,
                isDownloadingInvoice: false
            };
        }
        case INVOICE_FAILURE: {
            return {
                ...billingHistory,
                isDownloadingInvoice: false
            };
        }
        default:
            return billingHistory;
    }
};

export default fetchBillingHistoryReducers;
